import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EnableEscCloseDirective } from '../../shared/directives/enable-esc-close.directive';

@Component({
  selector: 'app-browser-compatibility-modal',
  templateUrl: './browser-compatibility-modal.component.html',
  styleUrl: './browser-compatibility-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  hostDirectives: [EnableEscCloseDirective],
})
export class BrowserCompatibilityModalComponent {

  constructor(private dialogRef: MatDialogRef<BrowserCompatibilityModalComponent>) {
  }

  public close(): void {
    this.dialogRef.close();
  }
}
